import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'shared/contexts/AuthContext';
import { getDefaultRouteForRole } from 'shared/utils/roleRedirects';

/**
 * RoleBasedRedirect component
 *
 * Redirects authenticated users to the appropriate landing page based on their role.
 */
export const RoleBasedRedirect: React.FC = () => {
  const { user } = useAuth();

  if (!user?.role) {
    return <Navigate to="/login" replace />;
  }

  // Resolve the user's home (non-external) company type so provider company_admins
  // land on /contractor/dashboard rather than the default client landing.
  const homeEntry = user?.companies?.find((c) => !c.isExternal);
  const homeCompany = homeEntry?.company;
  const companyType: 'cliente' | 'proveedor' | undefined =
    homeCompany && typeof homeCompany === 'object'
      ? homeCompany.companyType
      : undefined;

  return <Navigate to={getDefaultRouteForRole(user.role, companyType)} replace />;
};

export default RoleBasedRedirect;
